import { render, staticRenderFns } from "./template13.vue?vue&type=template&id=db0bc77c&scoped=true"
import script from "./template13.vue?vue&type=script&lang=js"
export * from "./template13.vue?vue&type=script&lang=js"
import style0 from "./template13.vue?vue&type=style&index=0&id=db0bc77c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0bc77c",
  null
  
)

export default component.exports